module.exports = __webpack_public_path__ + "img/R06_ON.4a4a7900.jpg";